import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { bemGenerator } from '@prisjakt/ui-base';
import Lazy from '../lazy';

import './card.scss';

const styles = bemGenerator('card', [
  'card-wrapper',
  'image-wrapper',
  'image-inner',
  'text-wrapper',
  'title',
  'preamble',
]);

function formatPreamble(str, maxLength) {
  return str && str.length > maxLength
    ? `${str
        .substr(0, str.substr(0, maxLength).lastIndexOf(' '))
        .trim()}\u00a0…`
    : str;
}

const Card = props => {
  const content = (
    <div className={styles['card-wrapper']}>
      <div className={styles['image-wrapper']}>
        {props.imageUrl && (
          <Lazy loadOnIdle>
            <div
              className={styles['image-inner']}
              style={{
                backgroundImage: `url(${props.imageUrl})`,
              }}
            />
          </Lazy>
        )}
      </div>
      <div
        className={styles['text-wrapper'].withModifier({
          'text-center': props.textCenter,
        })}
      >
        <h3 className={styles.title}>{props.title}</h3>
        {props.preamble && (
          <p className={styles.preamble}>
            {formatPreamble(props.preamble, props.preambleMaxLength)}
          </p>
        )}
      </div>
    </div>
  );
  return (
    <div className={styles.block}>
      {props.pathName ? <Link to={props.pathName}>{content}</Link> : content}
    </div>
  );
};

Card.propTypes = {
  imageUrl: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  preamble: PropTypes.string,
  preambleMaxLength: PropTypes.number,
  pathName: PropTypes.string,
  textCenter: PropTypes.bool,
};

Card.defaultProps = {
  preamble: undefined,
  preambleMaxLength: 80,
  pathName: undefined,
  textCenter: false,
};

export default Card;
